import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function PrivacyPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navItems = [
    { id: 'inicio', label: 'Inicio', action: () => navigate('/') },
    { id: 'servicios', label: 'Servicios', action: () => { navigate('/'); setTimeout(() => document.getElementById('servicios')?.scrollIntoView({ behavior: 'smooth' }), 100); } },
    { id: 'nosotros', label: 'Nosotros', action: () => { navigate('/'); setTimeout(() => document.getElementById('nosotros')?.scrollIntoView({ behavior: 'smooth' }), 100); } },
    { id: 'testimonios', label: 'Testimonios', action: () => { navigate('/'); setTimeout(() => document.getElementById('testimonios')?.scrollIntoView({ behavior: 'smooth' }), 100); } },
    { id: 'galeria', label: 'Galería', action: () => { navigate('/'); setTimeout(() => document.getElementById('galeria')?.scrollIntoView({ behavior: 'smooth' }), 100); } },
    { id: 'contacto', label: 'Contacto', action: () => { navigate('/'); setTimeout(() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' }), 100); } }
  ];

  const sections = [
    {
      title: '1. Información que Recopilamos',
      content: [
        'Recopilamos información personal que usted nos proporciona directamente cuando:',
        '• Solicita un presupuesto o servicio a través de nuestro formulario de contacto',
        '• Se comunica con nosotros por teléfono, email o WhatsApp',
        '• Utiliza nuestro asistente virtual Readdy Agent',
        '',
        'La información que podemos recopilar incluye:',
        '• Nombre completo',
        '• Dirección de correo electrónico',
        '• Número de teléfono',
        '• Dirección del servicio',
        '• Detalles sobre el servicio de fontanería requerido'
      ]
    },
    {
      title: '2. Uso de la Información',
      content: [
        'Utilizamos la información recopilada para:',
        '• Proporcionar y mejorar nuestros servicios de fontanería',
        '• Responder a sus consultas y solicitudes de presupuesto',
        '• Programar citas y servicios de emergencia',
        '• Enviar confirmaciones y recordatorios de citas',
        '• Comunicarnos sobre el estado de su servicio',
        '• Mejorar la experiencia del cliente',
        '• Cumplir con obligaciones legales y fiscales'
      ]
    },
    {
      title: '3. Protección de Datos',
      content: [
        'Nos comprometemos a proteger su información personal:',
        '• Implementamos medidas de seguridad técnicas y organizativas',
        '• Limitamos el acceso a su información solo al personal autorizado',
        '• No vendemos ni compartimos su información con terceros sin su consentimiento',
        '• Utilizamos conexiones seguras (HTTPS) en nuestro sitio web',
        '• Cumplimos con el Reglamento General de Protección de Datos (RGPD)'
      ]
    },
    {
      title: '4. Cookies y Tecnologías Similares',
      content: [
        'Nuestro sitio web puede utilizar cookies para:',
        '• Mejorar la funcionalidad del sitio',
        '• Analizar el tráfico y uso del sitio web',
        '• Recordar sus preferencias',
        '',
        'Puede configurar su navegador para rechazar cookies, aunque esto puede afectar la funcionalidad del sitio.'
      ]
    },
    {
      title: '5. Compartir Información',
      content: [
        'Podemos compartir su información únicamente con:',
        '• Proveedores de servicios que nos ayudan a operar nuestro negocio (hosting, email, etc.)',
        '• Autoridades legales cuando sea requerido por ley',
        '',
        'Todos los terceros están obligados a mantener la confidencialidad de su información.'
      ]
    },
    {
      title: '6. Sus Derechos',
      content: [
        'Bajo el RGPD, usted tiene derecho a:',
        '• Acceder a su información personal',
        '• Rectificar datos incorrectos o incompletos',
        '• Solicitar la eliminación de sus datos',
        '• Oponerse al procesamiento de sus datos',
        '• Solicitar la portabilidad de sus datos',
        '• Retirar su consentimiento en cualquier momento',
        '',
        'Para ejercer estos derechos, contáctenos en: fontaneriaelrapido@gmail.com'
      ]
    },
    {
      title: '7. Retención de Datos',
      content: [
        'Conservamos su información personal solo durante el tiempo necesario para:',
        '• Cumplir con los fines para los que fue recopilada',
        '• Cumplir con obligaciones legales, fiscales y contables',
        '• Resolver disputas y hacer cumplir nuestros acuerdos',
        '',
        'Generalmente, conservamos los datos de clientes durante 5 años después del último servicio prestado.'
      ]
    },
    {
      title: '8. Menores de Edad',
      content: [
        'Nuestros servicios están dirigidos a personas mayores de 18 años.',
        'No recopilamos intencionalmente información de menores de edad.',
        'Si descubrimos que hemos recopilado información de un menor, la eliminaremos de inmediato.'
      ]
    },
    {
      title: '9. Enlaces a Terceros',
      content: [
        'Nuestro sitio web puede contener enlaces a sitios de terceros (WhatsApp, Google Maps, etc.).',
        'No somos responsables de las prácticas de privacidad de estos sitios.',
        'Le recomendamos revisar las políticas de privacidad de cualquier sitio que visite.'
      ]
    },
    {
      title: '10. Cambios a esta Política',
      content: [
        'Podemos actualizar esta Política de Privacidad ocasionalmente.',
        'Los cambios se publicarán en esta página con la fecha de actualización.',
        'Le recomendamos revisar esta política periódicamente.',
        'El uso continuado de nuestros servicios después de los cambios constituye su aceptación de la política actualizada.'
      ]
    },
    {
      title: '11. Contacto',
      content: [
        'Si tiene preguntas sobre esta Política de Privacidad o sobre cómo manejamos sus datos personales, puede contactarnos:',
        '',
        '📧 Email: fontaneriaelrapido@gmail.com',
        '📞 Teléfono: +34 640 920 362',
        '📍 Ubicación: Valladolid, España',
        '',
        'Responderemos a su consulta en un plazo máximo de 30 días.'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-24">
            {/* Logo */}
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-4 cursor-pointer"
            >
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#FFD700] to-[#FFA500] flex items-center justify-center shadow-lg">
                <img
                  src="https://static.readdy.ai/image/4f9829bb3ae345389ad4c282efba233c/e0de52b8400c4ce07cfdbea4cb7e414b.png"
                  alt="Logo"
                  className="h-10 w-auto"
                />
              </div>
              <div className="text-gray-900">
                <div className="text-xl font-bold leading-tight">Fontanería El Rápido</div>
                <div className="text-xs opacity-80 uppercase tracking-wider">Servicio Premium</div>
              </div>
            </button>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-2">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={item.action}
                  className="px-5 py-2.5 rounded-lg text-sm font-semibold transition-all cursor-pointer whitespace-nowrap text-gray-700 hover:text-[#FFA500] hover:bg-gray-50"
                >
                  {item.label}
                </button>
              ))}
            </div>

            {/* CTA Button */}
            <div className="hidden lg:flex items-center gap-4">
              <a
                href="tel:+34640920362"
                className="bg-gradient-to-r from-[#FFD700] to-[#FFA500] text-black px-8 py-4 rounded-full text-sm font-bold hover:shadow-2xl hover:shadow-[#FFD700]/50 transition-all flex items-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill"></i>
                </div>
                640 920 362
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => {
                const mobileMenu = document.getElementById('mobile-menu');
                if (mobileMenu) {
                  mobileMenu.classList.toggle('hidden');
                }
              }}
              className="lg:hidden w-12 h-12 flex items-center justify-center rounded-xl transition-colors cursor-pointer text-gray-900 hover:bg-gray-100"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-menu-line text-2xl"></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div id="mobile-menu" className="hidden lg:hidden bg-white shadow-xl">
          <div className="max-w-7xl mx-auto px-6 py-6">
            <div className="flex flex-col gap-2">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => {
                    item.action();
                    document.getElementById('mobile-menu')?.classList.add('hidden');
                  }}
                  className="text-left px-5 py-4 rounded-xl text-gray-700 hover:text-[#FFA500] hover:bg-gray-50 transition-all font-semibold cursor-pointer"
                >
                  {item.label}
                </button>
              ))}
              <a
                href="tel:+34640920362"
                className="mt-4 bg-gradient-to-r from-[#FFD700] to-[#FFA500] text-black px-8 py-4 rounded-full text-sm font-bold hover:shadow-xl transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill"></i>
                </div>
                Llamar: 640 920 362
              </a>
            </div>
          </div>
        </div>
      </nav>
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#EFF6FF] to-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center">
            <div className="inline-block px-6 py-2 border-2 border-[#3B82F6] rounded-full mb-6">
              <span className="text-[#3B82F6] text-sm font-semibold">Legal</span>
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold text-[#1e3a8a] mb-6">
              Política de
              <span className="block text-[#3B82F6] mt-2">Privacidad</span>
            </h1>
            <p className="text-lg text-gray-600 mb-4">
              En Fontanería El Rápido, respetamos su privacidad y nos comprometemos a proteger sus datos personales.
            </p>
            <p className="text-sm text-gray-500">
              Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          {/* Introduction */}
          <div className="bg-gradient-to-br from-[#EFF6FF] to-white rounded-2xl p-8 border border-[#3B82F6]/20 mb-12">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#3B82F6] to-[#2563EB] flex items-center justify-center flex-shrink-0">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a8a] mb-3">Introducción</h2>
                <p className="text-gray-700 leading-relaxed">
                  Esta Política de Privacidad describe cómo <strong>Fontanería El Rápido</strong> recopila, utiliza y protege 
                  la información personal que usted nos proporciona a través de nuestro sitio web y servicios. Al utilizar 
                  nuestros servicios, usted acepta las prácticas descritas en esta política.
                </p>
              </div>
            </div>
          </div>

          {/* Sections */}
          <div className="space-y-8">
            {sections.map((section, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-[#3B82F6]/30 transition-all">
                <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#3B82F6]/10 to-[#2563EB]/10 flex items-center justify-center flex-shrink-0">
                    <span className="text-[#3B82F6] font-bold text-lg">{index + 1}</span>
                  </div>
                  {section.title}
                </h2>
                <div className="pl-13 space-y-2">
                  {section.content.map((paragraph, pIndex) => (
                    <p key={pIndex} className={`text-gray-700 leading-relaxed ${paragraph === '' ? 'h-2' : ''}`}>
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Contact CTA */}
          <div className="mt-16 bg-gradient-to-br from-[#3B82F6] to-[#2563EB] rounded-2xl p-10 text-center text-white">
            <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-question-line text-3xl"></i>
              </div>
            </div>
            <h3 className="text-3xl font-bold mb-4">¿Tienes Preguntas?</h3>
            <p className="text-white/90 mb-8 max-w-2xl mx-auto">
              Si tienes alguna duda sobre nuestra Política de Privacidad o sobre cómo manejamos tus datos, 
              no dudes en contactarnos. Estamos aquí para ayudarte.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="mailto:fontaneriaelrapido@gmail.com"
                className="bg-white text-[#3B82F6] px-8 py-4 rounded-full font-bold hover:shadow-xl transition-all flex items-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </div>
                <span>Enviar Email</span>
              </a>
              <a
                href="tel:+34640920362"
                className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-full font-bold hover:bg-white/20 transition-all flex items-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </div>
                <span>Llamar Ahora</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
